<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-form-item label="路线名称" prop="name">
          <el-input size="mini" v-model.trim="table.params.name" placeholder="请输入" clearable
            @keydown.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="食堂名称" prop="address_id">
          <el-select v-model="table.params.address_id" filterable placeholder="请选择" clearable style="width:100%;">
            <el-option v-for="item in storeArr" :label="`${item.name}(${item.merchant_name})`" :value="item.id"
              :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
          <el-button icon="el-icon-refresh-right" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="btnAdd">
        <el-button :size="subUnitSize" type="primary" icon="el-icon-plus" @click="showEdit">添加路线</el-button>
      </div>
    </div>

    <div class="curTableWrap" ref="main">
      <el-table v-if="refreshTable" :data="table.data" :height="height" border size="mini" ref="refTable"
        :default-expand-all="isExpandAll" header-align="center" align="center" v-loading="table.loading"
        element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)" :header-cell-style="{ background: '#f5f5f5' }" row-key="id"
        style="width: 100%">

        <el-table-column type="expand" style="padding:0 !important;" width="60">
          <template slot="header">
            <el-tooltip effect="dark" :content="isExpandAll ? `收起` : `展开`" placement="bottom">
              <i class="el-icon-menu" color="#2cb167" style="color:#2cb167" @click="toggleExpand"></i>
            </el-tooltip>
          </template>
          <template slot-scope="{row}">
            <div class="demo-table-expand" v-if="row.address.length > 0">
              <div class="specwrap" v-for="(item, index) in row.address" :key="index">
                <div class="specitem" style="display:flex;justify-content: space-between;">
                  <div class="cell-ellipsis" style="width:160px;padding-right:3px;border-right:solid 1px #eee;"
                    :title="item.code">{{ item.code }}</div>
                  <div class="cell-ellipsis" style="width:300px;padding-right:3px;border-right:solid 1px #eee;"
                    :title="item.name">{{ item.name }}</div>
                  <div class="cell-ellipsis" style="flex:1;min-width:0;padding-right:3px;border-right:solid 1px #eee;"
                    :title="`${item.province_str}${item.city_str}${item.area_str}${item.address}`">{{
                      `${item.province_str + item.city_str + item.area_str + item.address}` }}</div>
                  <div style="width:200px !important;border-right:solid 1px #eee;">{{ item.create_time }}</div>
                  <div style="width:200px;">
                    <span class="textBtn" style="margin-right:10px;" @click="eddcanteen(item, row)">编辑</span>
                    <span class="textBtn" @click="removeChild(item)">删除</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="序号" type="index" align="center" width="80">
        </el-table-column>
        <el-table-column label="路线名称" prop="name" align="center" min-width="140px">
        </el-table-column>
        <el-table-column label="食堂个数" prop="address" align="center" min-width="80px">
          <template slot-scope="{row}">
            <span>{{ row.address ? row.address.length : 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="配送员" prop="delivery" align="center" min-width="120px">
          <template slot-scope="{row}">
            <span>{{row.delivery && row.delivery.length ? row.delivery.map(i => i.name).join('、') : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" align="center" width="200">
        </el-table-column>
        <el-table-column label="操作" prop="active" align="center" width="200">
          <template slot-scope="{row}">
            <el-button type="text" @click="showEdit(row)">编辑</el-button>
            <el-button type="text" @click="addcanteen(row)">添加食堂</el-button>
            <el-button type="text" @click="remove(row)" v-if="!row.address.length">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class='pagination__wrap'>
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page="table.params.page"
          :page-size="table.params.count" :total="table.total" :page-sizes="[10, 20, 50, 100, 150]"
          @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <!-- 编辑 -->
    <edit ref="edit" @refresh="getTable" @addCanteen="addcanteen"></edit>
    <addCanteenDialog ref="addCanteenDialogRef" @refresh="getTable"></addCanteenDialog>
  </div>
</template>

<script>
import Edit from './components/Edit.vue';
import addCanteenDialog from './components/addCanteenDialog.vue';
import VTable from '@/components/VTable';
import { mixinTable } from '@/mixins/table.js'

export default {
  name: 'orderCateIndex',
  components: {
    Edit,
    VTable,
    addCanteenDialog,
  },
  mixins: [mixinTable],
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      height: 0,
      isExpandAll: true,
      refreshTable: true,

      field: [
        { name: "id", label: "ID", width: '80', hidden: false },
        { name: "name", label: "下单分类名称", hidden: false },
        { name: "sort", label: "排序", hidden: false },
        { name: "goods_num", label: "商品数量", hidden: false },
        { name: "cate", label: "匹配商品分类", hidden: false },
        { name: "create_time", label: "创建时间", hidden: false },
        { name: "action", label: "操作", width: "160", fixed: "right", hidden: false }
      ],
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
          address_id:'',
          name:'',
        },
        data: [],
        total: 0,
      },
      form: {
        loading: false,
        data: {
          pid: '', // 父id
          pName: '', // 父名称
          id: '',  // 子id
          name: '', // 子名称
          sort: '', // 子排序
        },
        rules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        }
      },
    }
  },
  created() {
    this.getTable();
    this.getStore();
  },
  mounted() {
    this.height = this.$refs.main.offsetHeight || 500
  },
  methods: {
    getStore() {
      this.$http.get('/admin/path/storeList', { params: { page: 1, count: 10000 } }).then(res => {
        if (res.code === 1) {
          this.storeArr = res.data.list;
        }
      })
    },
    getTable() {
      this.table.loading = true;
      this.$http.get('/admin/line/list', { params: this.table.params }).then(res => {
        if (res.code === 1) {
          this.table.loading = false;
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          // this.table.data = res.data.list.map(obj => ({ ...obj })).reduce((acc, obj) => {
          //   if (obj.child.length == 0) {
          //     delete obj.child;
          //     acc.push(obj);
          //   } else {
          //     acc.push(obj);
          //   }
          //   return acc;
          // }, []);
          console.log(this.table.data, "123")
        }
      })
    },
    addcanteen(row) {
      let dom = this.$refs.addCanteenDialogRef;
      dom.toggle(true);
      dom.getDetail(row, '新增');
      dom = null;
    },
    eddcanteen(item, row) {
      let dom = this.$refs.addCanteenDialogRef;
      dom.toggle(true);
      let obj = {
        ...row,
        cId: item.id,
        sort: item.sort,
        address_id: item.address_id,
      }
      dom.getDetail(obj, '编辑');
      dom = null;
    },
    // 新增、编辑
    showEdit(row) {
      let dom = this.$refs.edit;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    // 删除
    remove(row) {
      this.setConfirm(
        `确认删除操作？`,
        { id: row.id },
        "/admin/line/delete"
      );
    },
    removeChild(row) {
      this.setConfirm(
        `确认删除操作？`,
        { id: row.id },
        "/admin/line/deleteStore"
      );
    },
    // 展开、收起规格
    toggleExpand() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      })
    },
    handleClose() {
      this.dialogVisibleForm = false;
      this.type = 1;
      this.form.data.id = '';
      this.form.data.name = '';
      this.form.data.sort = '';
      this.form.data.pid = '';
      this.form.data.pName = '';
    },
  }
}
</script>
<style scoped>
::v-deep .el-table__expanded-cell {
  padding: 0 !important;
}

.curTableWrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px;
  background: #fff;
  flex: 1;
  overflow-y: scroll;
}

.curTableWrap::-webkit-scrollbar {
  width: 0px;
}

.curTableWrap::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 0px;
}

.pagination__wrap {
  margin: 10px 0;
  text-align: right;
  /* padding-right: 40px; */
}

.specitem {
  border-bottom: solid 1px #eee;
  display: flex;
  justify-content: space-between;
  text-align: center;
  height: 40px;
  line-height: 40px;
  background: #f8fffb;
}

.cell-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.specitem .item {
  border-right: solid 1px #eee;
  text-align: center;
  flex: 1;
}

.specitem .item:last-child {
  border-right: none;
}

.specitem .textBtn {
  color: #e6a23c;
  cursor: pointer;
}

.specitem .textBtn:hover {
  text-decoration: underline;
}

.childItem {
  color: #e6a23c;
  cursor: pointer;
  width: 134px;
  display: inline-block;
  text-align: center;
}

.childItem:hover {
  text-decoration: underline;
}
</style>
